export default "__VITE_ASSET__CNJjlO3L__"